import React from "react";
import {
    Box, Stack, Tab, Tabs, TextField, Typography,
} from "@mui/material";
import AddRoundedIcon                from "@mui/icons-material/AddRounded";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";
import "dayjs/locale/ko";
import { ADMIN_TYPE_FILTERS, TAB_EMPTY_MSG, TAB_STATUS_FILTERS } from "./approvalConstants";
import { ds } from "../../styles/designSystem";
import LoadingDots from "../../component/common/LoadingDots";
import ActionButton from "../../component/common/ActionButton";
import ComboBox from "../../component/common/ComboBox";
import ApprovalTable from "./ApprovalTable";

/* ── ApprovalNormalPanel — 표 형식 목록 + 탭 + 드롭다운 필터 ─── */
export default function ApprovalNormalPanel({
    tab,
    setTab,
    approvals,
    loading,
    filtered,
    statusFilter,
    setStatusFilter,
    submitterFilter,
    setSubmitterFilter,
    typeFilter,
    setTypeFilter,
    selected,
    onSelect,
    isAdmin,
    onEnterAdmin,
    onOpenCreate,
}) {
    const statusCount = (value) => approvals.filter((a) => a.status === value).length;

    const anyFilter = statusFilter !== "ALL" || typeFilter !== "ALL" || (submitterFilter || "").trim();
    const emptyText = anyFilter ? "조건에 맞는 결재가 없습니다" : TAB_EMPTY_MSG[tab];

    const ddSx = (w) => ({ width: w, flexShrink: 0 });

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* 헤더 */}
            <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
                <Box>
                    <Typography sx={{ fontWeight: 800, fontSize: 18, color: "#0f172a" }}>결재</Typography>
                    <Typography sx={{ fontSize: 12, color: "#94a3b8", mt: 0.2 }}>결재 문서를 작성·조회하고 승인/반려를 처리합니다.</Typography>
                </Box>
                <Stack direction="row" spacing={1}>
                    {isAdmin && (
                        <ActionButton variant="secondary"
                            startIcon={<AdminPanelSettingsRoundedIcon sx={{ fontSize: 14 }} />}
                            onClick={onEnterAdmin}
                            label="관리자 모드"
                            sx={{ fontSize: 12, py: 0.4, color: "#2563eb", borderColor: "#93c5fd",
                                "&:hover": { bgcolor: "#eff6ff", borderColor: "#2563eb" } }} />
                    )}
                    <ActionButton variant="primary"
                        startIcon={<AddRoundedIcon sx={{ fontSize: 15 }} />}
                        onClick={onOpenCreate}
                        label="올리기" />
                </Stack>
            </Stack>

            <Box sx={{ borderTop: "1px solid #e2e8f0", pt: 1 }}>
                <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={ds.components.tabs.compact} style={{paddingBottom: 10}}>
                    <Tab label="전체 보기" />
                    <Tab label="받은 결재" />
                    <Tab label="처리 완료" />
                    <Tab label="올린 결재" />
                </Tabs>

                {/* 드롭다운 필터 바 (모든 탭 공통, 한 줄): 상태 · 결재유형 · 기안자 검색 */}
                <Stack direction="row" spacing={1} alignItems="center" sx={{ py: 1.25 }}>
                    <Box sx={ddSx(128)}>
                        <ComboBox clearable={false} placeholder="상태"
                            options={TAB_STATUS_FILTERS[tab].map((f) => ({
                                value: f.value,
                                label: `${f.label}${f.value !== "ALL" ? ` (${statusCount(f.value)})` : ""}`,
                            }))}
                            value={statusFilter}
                            onChange={(v) => setStatusFilter(v)} />
                    </Box>

                    <Box sx={ddSx(140)}>
                        <ComboBox clearable={false} placeholder="결재유형"
                            options={ADMIN_TYPE_FILTERS.map((f) => ({ value: f.value, label: f.label }))}
                            value={typeFilter}
                            onChange={(v) => setTypeFilter(v)} />
                    </Box>

                    <TextField size="small" value={submitterFilter}
                        onChange={(e) => setSubmitterFilter(e.target.value)}
                        placeholder="기안자 이름/부서 검색"
                        sx={{ flex: 1, minWidth: 280 }} />
                </Stack>

                {loading
                    ? <LoadingDots />
                    : <ApprovalTable rows={filtered} selected={selected} onSelect={onSelect} emptyText={emptyText} />}
            </Box>
        </Box>
    );
}
